import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {

  private pathApi = this.config.setting['pathApi'] + "auditLog/";

  constructor(private http: HttpClient, private config: AppConfig) { }
  
  getAll(obj : any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj);
  } 
}
